// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { PanelNames } from '../UtilsClasses/FactoryConstants';
import { ApplicationPanel } from './ApplicationPanel';
import WebAdminPanelReact from '../ReactControls/panels/WebAdminPanelReact';
export class WebAdminPanel extends ApplicationPanel {
    constructor() {
        super(...arguments);
        this.headerLocaleKey = 'ribbon.tools.web_admin';
    }
    getType() {
        return PanelNames.WebAdminPanel;
    }
    oncomplete() {
        super.oncomplete();
        this.center();
        this.localize();
    }
    dispose() {
        super.dispose();
    }
}
ApplicationPanel.extendWith(WebAdminPanel, {
    Name: 'WebAdminPanel',
    mountContainer: '.webadminpanel',
    reactComponent: WebAdminPanelReact,
    data: function () {
        return {
            showHeader: true,
            showFooter: false,
            dockablePanel: false,
            attached: false,
            resizable: true,
            width: 850,
            height: 600,
            canLinkByAccount: false
        };
    },
    partials: {
        bodyPartial: '<div class="webadminpanel"></div>'
    }
});
export function ShowWebAdminPanel() {
    const newPanel = new WebAdminPanel();
    MainWindowManager.AddControl(newPanel);
}
